module.exports = ".container-fullscreen {\n  position: fixed;\n  top: 0;\n  z-index: 999999;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: white; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/full-screen/full-screen.component.scss
// module id = ./src/app/full-screen/full-screen.component.scss
// module chunks = main